import React from 'react'
import PropTypes from 'prop-types'
import Assignee, { getFullNameForAssignee } from '../../../components/Assignee'
import './AssigneeList.scss'

const getAssignee = (assignment, index, assignments) => {
  if (index <= 1) {
    return <Assignee key={assignment.id} assignment={assignment} />
  }

  if (index === 2) {
    let remainingAssignments = assignments.slice(2, assignments.length)
      .map(assignment => getFullNameForAssignee(assignment))
      .join(', ')
    return <span key='remaining' className='remaining' title={remainingAssignments}>+{assignments.length - 2}</span>
  }
}

const AssigneeList = props => {
  return (
    <div className='assigneeList'>
      {props.assignments.map(getAssignee)}
    </div>
  )
}

AssigneeList.propTypes = {
  assignments: PropTypes.array
}

export default AssigneeList



// WEBPACK FOOTER //
// ./src/routes/Board/components/AssigneeList.js